import { BrandID } from '@/types/common/course'

export const CryptoCourses = [BrandID.BTC, BrandID.ETH, BrandID.INVERSE_BTC, BrandID.INVERSE_ETH]
